import React, { Fragment } from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";

const AmountDetails = ({ data }) => {
  const styles = StyleSheet.create({
    container: {
      flexDirection: "row",
      alignItems: "center",
      fontStyle: "bold",
      paddingBottom: "5px",
      paddingTop: "10px",
      paddingLeft: "15px",
      border: "1px solid #E4E4E4",
      borderRadius: "5px",
      width: "100%",
      marginTop: "5px",
    },
    one: {
      width: "25%",
      fontSize: "11px",
      color: "#333333",
      flexDirection: "row",
      justifyContent: "space-between",
      marginRight: "10px",
      alignItems: "flex-end",
    },
    two: {
      width: "25%",
      fontSize: "11px",
      color: "#333333",
      flexDirection: "row",
      justifyContent: "space-between",
      marginRight: "10px",
      alignItems: "flex-end",
    },
    three: {
      width: "25%",
      fontSize: "11px",
      color: "#333333",
      flexDirection: "row",
      justifyContent: "space-between",
      marginRight: "10px",
      alignItems: "flex-end",
    },
    four: {
      width: "25%",
      fontSize: "11px",
      color: "#333333",
      flexDirection: "row",
      justifyContent: "space-between",
      marginRight: "10px",
      alignItems: "flex-end",
    },
    amount: {
      flexDirection: "column",
    },
    lightContainer: {
      color: "#454545",
      opacity: 0.52,
    },
    darkContainer: {
      color: "#454545",
    },
  });

  return (
    <Fragment>
      <View style={styles.container}>
        <View style={styles.one}>
          <View style={styles.amount}>
            <Text style={styles.lightContainer}>Total Expense</Text>
            <Text style={styles.darkContainer}>INR {data?.total_amount}</Text>
          </View>
          <View>
            <Text style={styles.darkContainer}>(-)</Text>
          </View>
        </View>
        <View style={styles.two}>
          <View style={styles.amount}>
            <Text style={styles.lightContainer}>Non Reimbursable</Text>
            <Text style={styles.darkContainer}>
              INR {data?.total_non_reimbursable_amount}
            </Text>
          </View>
          <View>
            <Text style={styles.darkContainer}>(-)</Text>
          </View>
        </View>
        <View style={styles.three}>
          <View style={styles.amount}>
            <Text style={styles.lightContainer}>Advance Received</Text>
            <Text style={styles.darkContainer}>
              INR {data?.total_advances_amount}
            </Text>
          </View>
          <View>
            <Text style={styles.darkContainer}>(=)</Text>
          </View>
        </View>
        <View style={styles.four}>
          <View style={styles.amount}>
            <Text style={styles.lightContainer}>Total Reimbursable</Text>
            <Text style={styles.darkContainer}>
              INR {data?.total_reimbursed_amount}
            </Text>
          </View>
        </View>
      </View>
    </Fragment>
  );
};

export default AmountDetails;
